import { render, staticRenderFns } from "./MemberProductsServicesBlock.vue?vue&type=template&id=224ed5a2&scoped=true"
import script from "./MemberProductsServicesBlock.vue?vue&type=script&lang=js"
export * from "./MemberProductsServicesBlock.vue?vue&type=script&lang=js"
import style0 from "./MemberProductsServicesBlock.vue?vue&type=style&index=0&id=224ed5a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224ed5a2",
  null
  
)

export default component.exports